import React from 'react';
import { cn } from '../utils/cn';
import './ColumnLabel.css';

/**
 * Small uppercase caption used above a control inside a SectionsCard column
 * (e.g. "Email", "Company", "Roles"). Optional leading icon.
 *
 * Ported from the reporting UI, restyled with plain CSS against tokens.css.
 */
export default function ColumnLabel({ icon: Icon, children, className }) {
  return (
    <div className={cn('sc-column-label', className)}>
      {Icon ? <Icon className="sc-column-label__icon" /> : null}
      {children}
    </div>
  );
}
